var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('splide',{attrs:{"options":_vm.options},on:{"splide:click":_vm.handleSlideClick}},_vm._l((_vm.slides),function(slide,i){return _c('splide-slide',{key:slide.id,staticClass:"slide",style:({
        'background-color': slide.color,
        'background-image': ("url(" + (slide.image) + ")"),
        'background-position': slide.position || 'center',
      }),attrs:{"data-index":i}},[_c('div',{staticClass:"max-w-6xl mx-auto h-full px-6 md:px-0 text-white",domProps:{"innerHTML":_vm._s(slide.body)}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }